import withLoader from "UIComponents/GqlWithLoader";
import comp from "./UnitList";
export default withLoader(comp);
